// Generated by genversion.
export const version = '2.25.0';
//# sourceMappingURL=version.js.map